import * as moment from 'moment';
import * as jQuery from 'jquery';

if (window) {
  window.moment = moment;
  window.$ = window.jQuery = jQuery;
}

import 'jquery';
import 'bootstrap';
import 'daterangepicker';

import 'angular';
import './components/locale/angular-locale_pt-br';
import './components/locale/moment-pt-br';

import '@uirouter/angularjs';

import 'address-autofill/dist/address-autofill';
import 'angular-animate';
import 'angular-aria';
import 'angular-br-filters';
import 'angular-cookies';
import 'angular-credit-cards';
import 'angular-daterangepicker';
import 'angular-google-maps';
import 'angular-input-masks';
import 'angular-local-storage';
import 'angular-material';
import 'angular-material-data-table';
import 'angular-messages';
import 'angular-moment';
import 'angular-resource';
import 'angular-sanitize';
import 'angular-ui-bootstrap';
import 'angular-ui-bootstrap-datetimepicker';
import 'ng-file-upload';
import 'ng-table/bundles/ng-table';
import 'ngstorage';
